<!-- eslint-disable -->
<template>
  <div class="p2s2_main_container">
    <div :class="{ p2s2_hidden_element: activeModal !== 'default'}" >
      <div class="p2s2_grid_container" >
        <div class="p2s2_button_area">
          <button class="c2m4_buttons" @click.stop="manageNotificationGroups">Notification Groups</button>
        </div>
        <div 
          class="p2s2_notifications_col"
          v-if="activeRuleUid !== null && 
                activeRuleUid !== undefined && 
                activeRuleNotificationJoins.length > 0" 
        >
          <div class="p2s2_rule_joins_header">
            <h3>Rule Assignments:</h3>
            <h4 class="p2s2_rule_joins_accronym_reference"></h4>
          </div>
          <div class="p2s2_rule_joins_list">
            <p2s2c2-rule-join-entry
              v-for="join in activeRuleNotificationJoins"
              :objectUid="join.objectUid"
              :objectAttributeUid="join.objectAttributeUid"
              :ruleJoinUid="join.uid"
              :selectedRuleJoinUid="activeRuleJoinUid"
              :doghouseFlag="join.type_doghouse"
              :instantFlag="join.type_instant"
              :reportFlag="join.type_daily"
              :key="join.uid"
              @event-select-rule-join="eventSelectRuleJoin"
              @event-edit-rule-join="eventEditRuleJoin"
              @event-set-children-visible="eventSetChildrenVisible"
            ></p2s2c2-rule-join-entry>
          </div>
        </div>
        <div 
          class="p2s2_empty_assignment_notification"
          v-if="activeRuleUid !== null && 
                activeRuleUid !== undefined && 
                activeRuleNotificationJoins.length < 1"
        >
          <h3>This rule is not assigned to any device attributes</h3>
        </div>

        <div class="p2s2_rules_title">Personal Rules
          <button class="c2m4_buttons" @click.stop="showCreateRuleModal">Create Rule</button>
        </div>
        <div></div>
        <div class="p2s2_rules">
          <p2s2c1-rule-entry
            v-for="rule in rulesList"
            :key="rule.uid"
            :ruleUid="rule.uid"
            :ruleName="rule.name"
            :selectedRuleUid="activeRuleUid"
            @event-select-rule="eventSelectRule"
            @event-edit-rule="eventEditRule"
            @event-delete-rule="eventDeleteRule"
            @event-set-children-visible="eventSetChildrenVisible"
          ></p2s2c1-rule-entry>
        </div>
      </div>
    </div>

    <div class="G_modal_container" v-if="activeModal !== 'default'">
      <p2s2m1-create-modify-rule
        v-if="activeModal === 'p2s2m1'"
        :ruleUid="activeRuleUid"
        :subItemIndex="1"
        :isModal="true"
        :subItemsList="subItemsList"
        :createEditFlag="createEditFlag"
        @event-close-modal="eventCloseModal"
        @event-sub-items-change="eventSubItemsChange"
        @event-parameter-change="eventParamsChange"
        @event-sub-items-loaded="eventSubItemsLoaded"
        @event-set-children-visible="eventSetChildrenVisible"
      ></p2s2m1-create-modify-rule>

      <c2m7-manage-notifications
        v-if="activeModal === 'c2m7'"
        :objectAttributeUid="activeRuleJoinObjectAttributeUid"
        :isModal="true"
        :subItemIndex="1"
        :subItemsList="subItemsList"
        :createEditFlag="createEditFlag"
        @event-close-modal="eventCloseModal"
        @event-sub-items-change="eventSubItemsChange"
        @event-parameter-change="eventParamsChange"
        @event-sub-items-loaded="eventSubItemsLoaded"
        @event-set-children-visible="eventSetChildrenVisible"
      ></c2m7-manage-notifications>

      <p2s2m2-notification-groups
        v-if="activeModal=='p2s2m2'"
        :isModal="true"
        :subItemIndex="subItemIndex + 1"
        :subItemsList="subItemsList"
        :parentParams="params"
        @event-close-modal="eventCloseModal"
        @event-sub-items-change="eventSubItemsChange"
        @event-parameter-change="eventParamsChange"
        @event-sub-items-loaded="eventSubItemsLoaded"
        @event-set-children-visible="eventSetChildrenVisible"
      ></p2s2m2-notification-groups>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import p2s2m1CreateModifyRule from "./p2s2m1CreateModifyRule";
import p2s2m2NotificationGroups from "./p2s2m2NotificationGroups";
import { bi10SubpageTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import AWN from "awesome-notifications";
import deleteRuleCall from "../../../watchdog_includes/json_tasks/p2s7/p2s7t6";
import p2s2c1RuleEntry from "./p2s2/p2s2c1RuleEntry";
import p2s2c2RuleJoinEntry from "./p2s2/p2s2c2RuleJoinEntry";
import c2m7ManageNotifications from "../p2s1MyOrganizations/c2m7ManageNotifications";

export default {
  name: "Notifications",
  components: {
    p2s2m1CreateModifyRule,
    p2s2c1RuleEntry,
    p2s2c2RuleJoinEntry,
    c2m7ManageNotifications,
    p2s2m2NotificationGroups
  },
  mixins: [bi10SubpageTemplate],
  data() {
    return {
      defaultModal: "default",
      createEditFlag: "",
      activeRuleUid: null,
      rulesList: {},
      activeRuleNotificationJoins: [],
      notificationRuleJoins: {},
      activeRuleJoinUid: null,
      activeRuleJoinObjectAttributeUid: null,
    };
  },
  methods: {
    waitWatchdogReadyCallback() {
      this.rulesList = window.G_watchdog_data.IV_notification_rules;
      this.notificationRuleJoins = window.G_watchdog_data.IV_notification_rule_joins;
    },
    showCreateRuleModal: function() {
      this.activeRuleUid = null;
      this.createEditFlag = "create";
      this.showModal("p2s2m1");
    },
    manageNotificationGroups() {
      this.activeRuleUid = null;
      this.showModal("p2s2m2");
    },
    eventSelectRule: function(rule_uid) {
      this.activeRuleUid = rule_uid;
    },
    eventEditRule: function(rule_uid) {
      this.activeRuleUid = rule_uid;
      this.createEditFlag = "edit";
      this.showModal("p2s2m1");
    },
    eventDeleteRule: function(rule_uid) {
      this.activeRuleUid = rule_uid;
      var popup_options = {
        labels: {
          confirm:
            "Permanently delete rule<br>'" +
            this.rulesList[rule_uid].name +
            "'<br>" +
            " including ALL rule assignments?",
        },
        modal: { okLabel: "Delete", cancelLabel: "Cancel" },
        position: "center",
      };
      var popup = new AWN(popup_options);
      popup.confirm("", this.confirmClearActiveNotifications);
      this.createEditFlag = "";
    },
    confirmClearActiveNotifications() {
      var vm = this;
      var popup_options = {
        labels: {
          confirm:
            "You want to clear all active alerts for this rule before deleting?"
        },
        modal: { okLabel: "Yes, Clear alerts", cancelLabel: "No, Keep alerts" },
        position: "center",
      };
      var popup = new AWN(popup_options);

      popup.confirm("", function() {vm.deleteRule(true);}, function() {vm.deleteRule(false);});
    },
    deleteRule: function(clear_alerts=false) {
      if (this.activeRuleUid === null) {return;}

      if (clear_alerts === true) {
        window.G_watchdog_data.bi7ClearActiveAlertsForRule(this.activeRuleUid);
      }
      deleteRuleCall(
        window.G_firebase_auth.IV_email_address, 
        window.G_firebase_auth.IV_id_token, 
        window.G_watchdog_data.IV_user_info.uid,
        this.activeRuleUid
      );
    },
    eventSelectRuleJoin: function(args) {
      this.activeRuleJoinUid = args[0];
      this.activeRuleJoinObjectAttributeUid = args[1];
    },
    eventEditRuleJoin: function() {
      this.showModal("c2m7");
    },
    updateRuleJoinsList() {
      var new_active_rule_join_list = [];
      for (var index in this.notificationRuleJoins) {
        if (this.notificationRuleJoins[index].rule_uid === this.activeRuleUid) {
          new_active_rule_join_list.push(this.notificationRuleJoins[index]);
        }
      }
      this.activeRuleNotificationJoins = new_active_rule_join_list;
    },
  },

  watch: {
    activeRuleUid: function() {
      this.updateRuleJoinsList();
    },
    notificationRuleJoins: {
      handler:
        function() {
          if (this.activeRuleUid === null) {
            return;
          }
          this.updateRuleJoinsList();
        }
      ,
      deep: true,
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2Notifications.vue